'use strict';

const GLOBAL_CONSTANTS = {
  ACCOUNT_NEWS_LIMIT: 12,
  ACCOUNT_PRIMARY_TAG_ID_LIST: [1, 2, 3, 4],
  BUSINESS_ALERTS_LIMIT: 12,
  CUSTOMER_SERVICE_EMAIL: 'serviceclient@nomination.fr',
  CONFERENCES_LIMIT: 12,
  ERROR_TYPE_LIST: [
    'default',
    'sequences',
    'campaigns',
  ],

  SEARCH_TIMEOUT: 1000,
  TEST_MODE: {
    TEMPLATE: 'Template',
  },
  TOPOL_API_KEY: 'OPgNyhWm4CONCLD5n2ToGMHikq00M337aPaGkyWuY93aIUZ9xj8gHJdHH3Aj',
  FROALA_FONT_FAMILY: {
    'Arial,Helvetica,sans-serif': 'Arial',
    'Calibri,sans-serif': 'Calibri',
    'Georgia,serif': 'Georgia',
    'Impact,Charcoal,sans-serif': 'Impact',
    'Poppins,sans-serif': 'Poppins',
    'Tahoma,Geneva,sans-serif': 'Tahoma',
    "'Times New Roman',Times,serif": 'Times New Roman',
    'Verdana,Geneva,sans-serif': 'Verdana',
  },
};

export {
  GLOBAL_CONSTANTS,
};
